<div nz-row [nzGutter]="[16, 32]" nzJustify="center">
  <div nz-col [nzSpan]="24">
    <ng-container *ngIf="isString(description); else descriptionTmpl">{{ description }}</ng-container>
    <ng-template #descriptionTmpl>
      <ng-container [ngTemplateOutlet]="$TemplateRef(renderer)" [ngTemplateOutletContext]="{$implicit: description}"></ng-container>
    </ng-template>
  </div>
  <div nz-col>
    <app-qr-code
      [qrCode]="qrCode$ | async"
    ></app-qr-code>
  </div>
  <div nz-col nzSpan="24">
    <p class="subtitle" i18n="@@QrCodeAssociation.Subtitle.Text">
      Ricorda che puoi configurare un solo telefono per volta.
    </p>
  </div>
</div>


<ng-template #renderer let-description>
  <ng-container *ngIf="description">
      <ng-container [ngTemplateOutlet]="$TemplateRef(description)"></ng-container>
  </ng-container>
</ng-template>
